import { withOpeningAndClosingBows } from './ceremony'
import type { KataDefinition } from './types'

/** Katame-no-Kata catalog — textbook labels, performance order. */
export const katameNoKata: KataDefinition = withOpeningAndClosingBows({
  id: 'katame-no-kata',
  name: 'Katame-no-Kata',
  nameJa: '固の形',
  theme: {
    from: '#ea580c',
    to: '#fb7185',
    text: '#0f172a',
  },
  groups: [
    {
      id: 'osaekomi-waza',
      name: 'Osaekomi-waza',
      nameJa: '抑込技',
      techniques: [
        { id: 'katame-kesa-gatame', name: 'Kesa-gatame', nameJa: '袈裟固' },
        { id: 'katame-kata-gatame', name: 'Kata-gatame', nameJa: '肩固' },
        { id: 'katame-kami-shiho-gatame', name: 'Kami-shiho-gatame', nameJa: '上四方固' },
        { id: 'katame-yoko-shiho-gatame', name: 'Yoko-shiho-gatame', nameJa: '横四方固' },
        {
          id: 'katame-kuzure-kami-shiho-gatame',
          name: 'Kuzure-kami-shiho-gatame',
          nameJa: '崩上四方固',
        },
      ],
    },
    {
      id: 'shime-waza',
      name: 'Shime-waza',
      nameJa: '絞技',
      techniques: [
        { id: 'katame-kata-juji-jime', name: 'Kata-juji-jime', nameJa: '片十字絞' },
        { id: 'katame-hadaka-jime', name: 'Hadaka-jime', nameJa: '裸絞' },
        { id: 'katame-okuri-eri-jime', name: 'Okuri-eri-jime', nameJa: '送襟絞' },
        { id: 'katame-kataha-jime', name: 'Kataha-jime', nameJa: '片羽絞' },
        { id: 'katame-gyaku-juji-jime', name: 'Gyaku-juji-jime', nameJa: '逆十字絞' },
      ],
    },
    {
      id: 'kansetsu-waza',
      name: 'Kansetsu-waza',
      nameJa: '関節技',
      techniques: [
        { id: 'katame-ude-garami', name: 'Ude-garami', nameJa: '腕緘' },
        {
          id: 'katame-ude-hishigi-juji-gatame',
          name: 'Ude-hishigi-juji-gatame',
          nameJa: '腕挫十字固',
        },
        {
          id: 'katame-ude-hishigi-ude-gatame',
          name: 'Ude-hishigi-ude-gatame',
          nameJa: '腕挫腕固',
        },
        {
          id: 'katame-ude-hishigi-hiza-gatame',
          name: 'Ude-hishigi-hiza-gatame',
          nameJa: '腕挫膝固',
        },
        { id: 'katame-ashi-garami', name: 'Ashi-garami', nameJa: '足緘' },
      ],
    },
  ],
})
